import BoqItemsFieldArray from "components/common/BoqItemsFieldArray";
import { QuotationItemType } from "features/Quotations/constants/quotation.constants";
import type { QuotationItemFormRow } from "features/Quotations/utils/quotationItem.utils";

export type MaterialRequestJobKind = "work_order" | "petty_work";

export type MaterialRequestBoqFieldArrayProps = {
  validation: any;
  readOnly?: boolean;
  /** Renders BOQ without its own card (for payment-style single-card forms). */
  embedded?: boolean;
  /** Controls BOQ helper copy (petty work lines are often pre-filled from the job). */
  jobKind: MaterialRequestJobKind;
};

/** Default BOQ row for new material-request lines (material-first, same shape as quotations). */
export function materialRequestEmptyBoqRow(): QuotationItemFormRow {
  return {
    type: QuotationItemType.MATERIAL,
    description: "",
    quantity: 1,
    unit: "",
    rate: 0,
  };
}

const MR_BOQ_TITLE = "Requested materials (BOQ)";

/**
 * Material-request BOQ editor: wraps the shared {@link BoqItemsFieldArray} with MR-specific
 * titles, defaults, and copy.
 */
export default function MaterialRequestBoqFieldArray({
  validation,
  readOnly = false,
  embedded = false,
  jobKind,
}: MaterialRequestBoqFieldArrayProps) {
  const cardSubtitle =
    jobKind === "work_order"
      ? "Material lines from this work order’s BOQ are pre-filled when possible; you can edit before submitting. Same layout as quotations. Only material lines are sent when you create the request."
      : "Material lines from this petty work’s BOQ are pre-filled when possible; you can edit before submitting. Same layout as quotations. Only material lines are sent when you create the request.";

  return (
    <BoqItemsFieldArray
      validation={validation}
      readOnly={readOnly}
      embedded={embedded}
      cardTitle={MR_BOQ_TITLE}
      cardSubtitle={cardSubtitle}
      addLineLabel="Add line"
      typeSelectDisabled
      getDefaultRow={materialRequestEmptyBoqRow}
    />
  );
}
